import React from "react";
import { playerType } from "./VideoPlay.type";
import ReactPlayer from "react-player";

const VideoPlay = (props: playerType) => {
  const {
    width,
    height,
    autoPlay,
    onEnded,
    src,
    onPause,
    onSeek,
    onPlay,
    playing,
  } = props;

  const noVideoUrl = "https://www.youtube.com/watch?v=Ul0FyB9q-js";

  return (
    <ReactPlayer
      url={src || noVideoUrl}
      className="react-player"
      playing={playing}
      onEnded={onEnded}
      onPause={onPause}
      onSeek={onSeek}
      onPlay={onPlay}
      controls={true}
      width="100%"
      height={height}
      playsinline
      data-testid="react-player"
    />
  );
};

export default VideoPlay;
